<template>
  <div>
    <h2 class="step-name">Drug Allocations</h2>

    <div class="alert alert-danger" v-if="expiredAllocations.length > 0">
      <strong> Please review the allocations, some of them expired. </strong>
      <p v-for="product in expiredAllocations" :key="'expired_allocation_'+product.id">
        {{ product.name }}
      </p>
    </div>

    <div class="step-section">
      <h4>How much of the winter consult allocations are used to date? Review and adjust as required.</h4>
      <input type="text" v-model="filter" class="form-control" placeholder="Search...">

      <div v-for="(drug_group, groupIndex) in model.drug_groups" :key="drug_group.name">
        <h3>
          <span class="glyphicon" :class="(shouldShowGroup(groupIndex)) ? 'glyphicon-chevron-down' : 'glyphicon-chevron-right'"> </span>
          <span @click="toggleGroup(groupIndex)">{{ drug_group.name }}</span>
        </h3>

        <div v-for="(drug, drugs_iteration_index) in filteredDrugs(drug_group.drugs)" :key="drug.pk">
            <div class="clearfix drug_group"  :class="{ show: shouldShowGroup(groupIndex),  hide: !shouldShowGroup(groupIndex)  }" :style="{ width: 400 + widthForRow(model.FARMS) + 'px' }">

              <div v-if="drug.inactive == false || model.last_year_usage[drug.pk] > 0">  <!-- show disabled products only if they got last year data. -->
                <div class="farm-fields">
                  <h4 v-if="drugs_iteration_index == 0">Qty used so far this season</h4>
                  <div class="form-group">
                    <label> {{ drug.name }} </label>
                    <input type="number" v-model="model.last_year_usage[drug.pk]" class="form-control" disabled>
                  </div>
                </div>

                <div v-for="farm in model.FARMS" class="farm-fields" :key="farm.id">
                  <h4 v-if="drugs_iteration_index == 0">{{ farm.farm_label }}</h4>

                  <div v-if="drug_group.pk == '15' && newAllocations[farm.id][drug.pk].is_pre_allocation" class="form-group" >
                    <label> {{ drug.name }} </label>
                    <div class="row">
                      <div class="col-md-6">
                        <input type="number" v-model="newAllocations[farm.id][drug.pk].par_qty" class="form-control"
                          :disabled="drug.inactive || isReadOnly || drug.disallow_allocations"
                          :placeholder="[ drug.inactive ? 'Disabled' : '' ]">

                        <span class="text-danger"> Expires {{ new Date(newAllocations[farm.id][drug.pk].par_end_date) | moment("DD-MM-YYYY") }} </span>
                      </div>

                      <div class="col-md-6">
                        <input type="number" v-model="newFutureAllocations[farm.id][drug.pk].par_qty" class="form-control" 
                          :disabled="drug.inactive || isReadOnly"
                          :placeholder="[ drug.inactive ? 'Disabled' : '' ]">

                        <span class="text-danger"> {{ futureAllocationDates(new Date(newAllocations[farm.id][drug.pk].par_end_date)) }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-else class="form-group">
                    <label> {{ drug.name }} </label>
                    <input type="number" v-model="newAllocations[farm.id][drug.pk].par_qty" class="form-control"
                      :disabled="drug.inactive || isReadOnly || drug.disallow_allocations"
                      :placeholder="[ drug.inactive ? 'Disabled' : '' ]">
                  </div>
                </div>
              </div>

            </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component'

export default {
  mixins: [ baseComponent ],
  data() {
    return {
      filter: '',
      groupVisibility: {
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false,
        9: false,
        10: false,
        11: false,
        12: false,
        13: false,
        14: false,
        15: false,
        16: false,
        17: false,
        18: false,
        19: false,
        20: false,
      },
      model: {
        FARMS: [],
        drug_groups: [],
        drugs_allocated: {},
        last_year_usage: {},
      },
      newAllocations: {},
      newFutureAllocations: {},
      expiredAllocations: [],
    }
  },
  created: function() {
    this.showBackendErrors()

    for (const farm of this.model.FARMS) {
      this.newFutureAllocations[farm.id] = {}
      this.newAllocations[farm.id] = {}

      for (const drugGroup of this.model.drug_groups) {
        for (const drug of drugGroup.drugs) {
          // Initialize newAllocations model
          this.newAllocations[farm.id][drug.pk] = {
            par_qty: 0,
            drug_allocation_product: drug.pk,
            is_pre_allocation: null,
            is_future_allocation: false,
            par_end_date: null,
          }

          // Initialize newFutureAllocations for Critically IA GROUP
          if (drugGroup.pk == '15') {
            this.newFutureAllocations[farm.id][drug.pk] = {
              par_qty: 0,
              drug_allocation_product: drug.pk,
              is_pre_allocation: null,
              is_future_allocation: true,
              par_end_date: null,
            }
          }
        }
      }

      for (const allocation of this.model.drugs_allocated[farm.id]) {
        let data = {
          par_qty: allocation.par_qty,
          drug_allocation_product: allocation.drug_allocation_product,
          is_pre_allocation: allocation.is_pre_allocation,
          is_future_allocation: allocation.is_future_allocation,
          par_end_date: allocation.par_end_date,
        }
        if (allocation.is_future_allocation) {
          this.newFutureAllocations[farm.id][allocation.drug_allocation_product] = data
        } else {
          this.newAllocations[farm.id][allocation.drug_allocation_product] = data
        }
      }
    }
  },
  computed: {
    searching: function () {
      return this.filter;
    },
  },
  methods: {
    toggleGroup: function (groupIndex) {
        this.groupVisibility[groupIndex] = !this.groupVisibility[groupIndex];
    },
    shouldShowGroup: function (groupIndex) {
      return this.searching || this.groupVisibility[groupIndex];
    },
    filteredDrugs: function(drugs) {
      if (this.filter) {
        let filteredDrugs = [];
        for (const drug of drugs)
        {
          if (drug.name.toLowerCase().includes(this.filter.toLowerCase()))
          {
            filteredDrugs.push(drug)
          }
        }
        return filteredDrugs;
      } else {
        return drugs
      }
    },
    onSubmit: function() {
      for (const farm of this.model.FARMS) {
          Object.entries(this.newAllocations[farm.id] || {}).forEach(([key, data]) => {
          let farmAllocations = this.model.drugs_allocated[farm.id]

          let alloc = farmAllocations.find(alloc => (alloc.drug_allocation_product == key && alloc.is_future_allocation == false))

          if (!data.par_qty) {
            data.par_qty = 0
          }

          if (alloc) {
            alloc.par_qty = data.par_qty
          } else if (data.par_qty > 0) {
            farmAllocations.push(data)
          }
        })

        Object.entries(this.newFutureAllocations[farm.id] || {}).forEach(([key, data]) => {
          let farmAllocations = this.model.drugs_allocated[farm.id]

          let alloc = farmAllocations.find(alloc => (alloc.drug_allocation_product == key && alloc.is_future_allocation == true))

          if (!data.par_qty) {
            data.par_qty = 0
          }

          if (alloc) {
            alloc.par_qty = data.par_qty
          } else if (data.par_qty > 0) {
            farmAllocations.push(data)
          }
        })
      }
      return baseComponent.methods.onSubmit.call(this)
    },
    futureAllocationDates: function(parEndDate) {
      let futureAllocationStartDate

      let today = new Date()

      if (parEndDate > today) {
        futureAllocationStartDate = this.$moment(parEndDate).add('1', 'days')
      } else {
        futureAllocationStartDate = this.$moment(today)
      }
      return futureAllocationStartDate.format("DD-MM-YYYY") + '  -  ' + futureAllocationStartDate.add('4', 'months').format("DD-MM-YYYY")
    },
    showBackendErrors(){
      var errors = this.$store.getters['winterConsult/sectionBackendErrors']
      var self = this

      if (errors) {
        if (errors['expired_pre_allocations']) {
          Object.entries(errors['expired_pre_allocations']).forEach(entry => {
            var [farmId, products] = entry;

            let removeProdIds = products.map(prod => prod.id)

            self.model.drugs_allocated[farmId] = self.model.drugs_allocated[farmId].filter(prod => !removeProdIds.includes(prod.drug_allocation_product))

            self.expiredAllocations = self.expiredAllocations.concat(products)
          });
        }
        this.$store.dispatch('winterConsult/deleteSectionBackendErrors', this.currentComponent)
      }
    },
  },
};
</script>

<style>
.drug_group.show { display: block;}
.drug_group.hide { display: none;}
</style>
